import {ActivityTypesEnum} from '../../../../../src/models/api/activityModel';
import {InboxModel} from '../../../../../src/models/api/inboxModel';
import {TeammateModel} from '../../../../../src/models/api/teammateModel';

export enum VisualBasicCollapsedActivityTypesEnum {
  // Priority 1.
  ASSIGNED_TO_USER = 'ASSIGNED_TO_USER',
  ASSIGNED_TO_USER_BY_RULE = 'ASSIGNED_TO_USER_BY_RULE',
  ASSIGNED_TO_USER_BY_API = 'ASSIGNED_TO_USER_BY_API',
  UNASSIGNED_FROM_USER = 'UNASSIGNED_FROM_USER',
  SNOOZE_EXPIRED = 'SNOOZE_EXPIRED',
  RULE_NOTIFIED_USER_WITH_RECIPIENT = 'RULE_NOTIFIED_USER_WITH_RECIPIENT',
  RULE_NOTIFIED_USER_WITHOUT_RECIPIENT = 'RULE_NOTIFIED_USER_WITHOUT_RECIPIENT',
  USER_INVITED = 'USER_INVITED',

  // Priority 2.
  ASSIGNED_TO_TEAMMATE = 'ASSIGNED_TO_TEAMMATE',
  ASSIGNED_TO_TEAMMATE_BY_RULE = 'ASSIGNED_TO_TEAMMATE_BY_RULE',
  ASSIGNED_TO_TEAMMATE_BY_API = 'ASSIGNED_TO_TEAMMATE_BY_API',
  UNASSIGNED_FROM_TEAMMATE = 'UNASSIGNED_FROM_TEAMMATE',
  UNASSIGNED_FROM_TEAMMATE_INACTIVITY = 'UNASSIGNED_FROM_TEAMMATE_INACTIVITY',
  UNASSIGNED_FROM_TEAMMATE_DELETED = 'UNASSIGNED_FROM_TEAMMATE_DELETED',
  MOVED_BY_TEAMMATE = 'MOVED_BY_TEAMMATE',
  MOVED_BY_RULE = 'MOVED_BY_RULE',
  ARCHIVED_IN_TEAM_INBOX = 'ARCHIVED_IN_TEAM_INBOX',
  SNOOZED_IN_TEAM_INBOX = 'SNOOZED_IN_TEAM_INBOX',
  REOPENED_IN_TEAM_INBOX = 'REOPENED_IN_TEAM_INBOX',
  TRASHED_IN_TEAM_INBOX = 'TRASHED_IN_TEAM_INBOX',
  RESTORED_IN_TEAM_INBOX = 'RESTORED_IN_TEAM_INBOX',

  // Priority 3.
  TAG_ADDED_BY_TEAMMATE = 'TAG_ADDED_BY_TEAMMATE',
  TAG_ADDED_BY_RULE = 'TAG_ADDED_BY_RULE',
  TAG_ADDED_BY_API = 'TAG_ADDED_BY_API',
  TAG_REMOVED_BY_TEAMMATE = 'TAG_REMOVED_BY_TEAMMATE',
  TAG_REMOVED_BY_RULE = 'TAG_REMOVED_BY_RULE',
  TAG_REMOVED_BY_API = 'TAG_REMOVED_BY_API',
  TEAMMATE_INVITED = 'TEAMMATE_INVITED',
  TEAMMATE_REMOVED = 'TEAMMATE_REMOVED',
  RULE_NOTIFIED_TEAMMATE = 'RULE_NOTIFIED_TEAMMATE',
}

interface CollapsedActivityBase {
  id: number;
  date: number;
  activityType: ActivityTypesEnum;
}

interface AssignedToUserCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.ASSIGNED_TO_USER;
  priority: 1;
}

interface AssignedToUserByRuleCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.ASSIGNED_TO_USER_BY_RULE;
  priority: 1;
}

interface AssignedToUserByApiCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.ASSIGNED_TO_USER_BY_API;
  priority: 1;
}

interface UnassignedFromUserCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.UNASSIGNED_FROM_USER;
  priority: 1;
}

interface SnoozeExpiredCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.SNOOZE_EXPIRED;
  priority: 1;
}

interface RuleNotifiedUserWithRecipientCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.RULE_NOTIFIED_USER_WITH_RECIPIENT;
  priority: 1;
}

interface RuleNotifiedUserWithoutRecipientCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.RULE_NOTIFIED_USER_WITHOUT_RECIPIENT;
  priority: 1;
}

interface UserInvitedCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.USER_INVITED;
  priority: 1;
}

interface AssignedToTeammateCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.ASSIGNED_TO_TEAMMATE;
  priority: 2;
  assignee: TeammateModel;
}

interface AssignedToTeammateByRuleCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.ASSIGNED_TO_TEAMMATE_BY_RULE;
  priority: 2;
  assignee: TeammateModel;
}

interface AssignedToTeammateByApiCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.ASSIGNED_TO_TEAMMATE_BY_API;
  priority: 2;
  assignee: TeammateModel;
}

interface UnassignedFromTeammateCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.UNASSIGNED_FROM_TEAMMATE;
  priority: 2;
}

interface UnassignedForInactivityCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.UNASSIGNED_FROM_TEAMMATE_INACTIVITY;
  priority: 2;
}

interface UnassignedFromTeammateDeletedCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.UNASSIGNED_FROM_TEAMMATE_DELETED;
  priority: 2;
}

interface MovedByTeammateCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.MOVED_BY_TEAMMATE;
  priority: 2;
  inbox: InboxModel;
}

interface MovedByRuleCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.MOVED_BY_RULE;
  priority: 2;
  inbox: InboxModel;
}

interface ArchivedInTeamInboxCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.ARCHIVED_IN_TEAM_INBOX;
  priority: 2;
}

interface SnoozedInTeamInboxCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.SNOOZED_IN_TEAM_INBOX;
  priority: 2;
}

interface ReopenedInTeamInboxCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.REOPENED_IN_TEAM_INBOX;
  priority: 2;
}

interface TrashedInTeamInboxCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TRASHED_IN_TEAM_INBOX;
  priority: 2;
}

interface RestoredInTeamInboxCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.RESTORED_IN_TEAM_INBOX;
  priority: 2;
}

interface TagAddedByTeammateCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TAG_ADDED_BY_TEAMMATE;
  priority: 3;
  addedTagCount: number;
}

interface TagAddedByRuleCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TAG_ADDED_BY_RULE;
  priority: 3;
  addedTagCount: number;
}

interface TagAddedByApiCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TAG_ADDED_BY_API;
  priority: 3;
  addedTagCount: number;
}

interface TagRemovedByRuleCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TAG_REMOVED_BY_RULE;
  priority: 3;
  removedTagCount: number;
}

interface TagRemovedByApiCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TAG_REMOVED_BY_API;
  priority: 3;
  removedTagCount: number;
}

interface TagRemovedByTeammateCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TAG_REMOVED_BY_TEAMMATE;
  priority: 3;
  removedTagCount: number;
}

interface TeammateInvitedCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TEAMMATE_INVITED;
  priority: 3;
  recipient: TeammateModel;
}

interface TeammateRemovedCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.TEAMMATE_REMOVED;
  priority: 3;
  recipient: TeammateModel;
}

interface RuleNotifiedTeammateCollapsedActivity extends CollapsedActivityBase {
  type: VisualBasicCollapsedActivityTypesEnum.RULE_NOTIFIED_TEAMMATE;
  priority: 3;
  recipient: TeammateModel;
}

export type VisualBasicCollapsedActivity =
  | AssignedToUserCollapsedActivity
  | AssignedToUserByRuleCollapsedActivity
  | AssignedToUserByApiCollapsedActivity
  | UnassignedFromUserCollapsedActivity
  | SnoozeExpiredCollapsedActivity
  | RuleNotifiedUserWithRecipientCollapsedActivity
  | RuleNotifiedUserWithoutRecipientCollapsedActivity
  | UserInvitedCollapsedActivity
  | AssignedToTeammateCollapsedActivity
  | AssignedToTeammateByRuleCollapsedActivity
  | AssignedToTeammateByApiCollapsedActivity
  | UnassignedFromTeammateCollapsedActivity
  | UnassignedForInactivityCollapsedActivity
  | UnassignedFromTeammateDeletedCollapsedActivity
  | MovedByTeammateCollapsedActivity
  | MovedByRuleCollapsedActivity
  | ArchivedInTeamInboxCollapsedActivity
  | SnoozedInTeamInboxCollapsedActivity
  | ReopenedInTeamInboxCollapsedActivity
  | TrashedInTeamInboxCollapsedActivity
  | RestoredInTeamInboxCollapsedActivity
  | TagAddedByTeammateCollapsedActivity
  | TagAddedByRuleCollapsedActivity
  | TagRemovedByRuleCollapsedActivity
  | TagAddedByApiCollapsedActivity
  | TagRemovedByApiCollapsedActivity
  | TagRemovedByTeammateCollapsedActivity
  | TeammateInvitedCollapsedActivity
  | TeammateRemovedCollapsedActivity
  | RuleNotifiedTeammateCollapsedActivity;
